/**
 * This program is free software; you can redistribute it and/or
 * modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation; under version 2
 * of the License (non-upgradable).
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program; if not, write to the Free Software
 * Foundation, Inc., 51 Franklin Street, Fifth Floor, Boston, MA  02110-1301, USA.
 *
 * Copyright (c) 2020 Open Assessment Technologies SA;
 */
import { isPlainText } from '../../blocks/blockTreeBuilder.js';

/**
 * Properties mapper for the GapMatch interaction
 */
export default {
    /**
     * Prepare interaction props
     * - move math blocks into choices
     * - set gaps data
     * - calculate cardinality based on gaps number
     * @param {object} properties - GapMatch properties
     * @param {object} element - GapMatch description
     * @param {string} element.body - GapMatch body
     * @returns {object} mapped properties
     */
    mapProperties(properties, { body } = {}) {
        if (properties.choices) {
            properties.choices.forEach(choice => {
                choice.isComplexContent = !isPlainText(choice.blockTree);
                const mathMlBlocks = choice.blockTree.filter(
                    block => block.props && block.props.attributes && block.props.attributes.mathML
                );
                mathMlBlocks.forEach(block => {
                    choice.content = choice.content.replace(
                        `{{${block.content}}}`,
                        `<math xmlns="http://www.w3.org/1998/Math/MathML">${block.props.attributes.mathML}</math>`
                    );
                });
            });
        }

        const elements = body && body.elements ? body.elements : {};
        properties.gaps = Object.values(elements).filter(el => el.qtiClass === 'gap').map(el => el.attributes);

        if (!properties.cardinality || typeof properties.cardinality !== 'string') {
            const cardinality = Object.keys(elements).length > 1 ? 'multiple' : 'single';
            return Object.assign({}, properties, { cardinality });
        }
        return properties;
    }
};
